import { s, tableTokens } from '@/theme/tokens';
import { dataGridFooterContainerChromeSx, tablePaginationChromeSx } from './tablePaginationChrome';
import type { SxProps, Theme } from '@mui/material/styles';

const dataGridStructureChromeSx: SxProps<Theme> = {
  '& .MuiDataGrid-columnHeader': {
    px: s('md'),
    pt: s('xs'),
    pb: s(tableTokens.cellPadding.y),
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-cell': {
    px: s(tableTokens.cellPadding.x),
    py: s('none'),
    display: 'flex',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
  },
  '& .MuiDataGrid-columnHeaderDraggableContainer': {
    paddingLeft: s('md'),
    paddingRight: s('md'),
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    paddingLeft: s('md'),
    paddingRight: s('md'),
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    paddingLeft: s('sm'),
    paddingRight: s('xs'),
  },
  '& .MuiDataGrid-cellContent': {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
    minWidth: 0,
    flex: '1 1 auto',
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
    paddingTop: s('xs'),
    boxSizing: 'border-box',
  },
};

export const dataGridChromeSx: SxProps<Theme> = [
  dataGridStructureChromeSx,
  dataGridFooterContainerChromeSx,
  tablePaginationChromeSx,
] as SxProps<Theme>;
